import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

// import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // Internationalization
import './icons' // icon
import './permission' // permission control

import * as filters from './filters' // global filters
// 通过指令permission  + permissionUrl 做权限控制按钮隐藏
import permission from '@/directive/permission'
import { dragMove } from '@/directive/dragMove'
// 使用 vue-meta
import Meta from 'vue-meta'

import VueClipboard from 'vue-clipboard2'
import EventBus from '@/utils/vue-bus'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.directive('ismove', dragMove)

Vue.directive('permission', permission)

Vue.prototype.$EventBus = EventBus

Vue.use(VueLodash)
Vue._ = lodash
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.$EventBus = new Vue()

Vue.use(Meta)

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
